import { FormField } from '../../../types/form-builder.types';

interface TextAreaFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export function TextAreaField({ field, value, onChange }: TextAreaFieldProps) {
  const config = field.config;

  return (
    <textarea
      id={field.id}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={config.placeholder}
      required={config.required}
      rows={typeof config.rows === 'number' ? config.rows : 4}
      minLength={config.minLength}
      maxLength={config.maxLength}
      className="easyforms-field-textarea"
    />
  );
}
